import React from 'react';
import { CompassIcon, FrownIcon, SmartphoneIcon, WrenchIcon } from 'lucide-react';
import { Reveal } from './ui/Reveal';
import { problems } from '../data/content';
const ICONS = {
  confused: FrownIcon,
  wrench: WrenchIcon,
  phone: SmartphoneIcon,
  compass: CompassIcon
};
export function ProblemSection() {
  return <section aria-labelledby="problema" className="border-b border-line bg-canvas" data-id="element-135" data-mp="2vowm4nmmeb2j">
      <div className="mx-auto max-w-3xl px-4 py-9 text-center sm:px-6" data-id="element-136" data-mp="39guq6k1h5gru">
        <p className="font-display text-[0.65rem] font-bold uppercase tracking-[0.16em] text-accent" data-id="element-137" data-mp="35gtyvyta1b3d">
          ¿Te pasa esto?
        </p>
        <h2 id="problema" className="mt-2 font-display text-lg font-extrabold leading-tight text-ink sm:text-2xl" data-id="element-138" data-mp="3jfjv7c89v6qo">
          Te gusta la Electrónica, pero ¿sentís que nunca terminás de avanzar?
        </h2>
        <p className="mx-auto mt-2 max-w-xl text-sm leading-relaxed text-ink-muted" data-id="element-139" data-mp="1p3vmhrsmw0eq">
          Si estás aprendiendo Electrónica, sos técnico, docente o querés
          emprender, probablemente conozcas alguna de estas situaciones:
        </p>

        <ul className="mt-5 grid gap-3 sm:grid-cols-2" data-id="element-140" data-mp="od9hybxl8cd7">
          {problems.map((problem, i) => {
          const Icon = ICONS[problem.icon];
          return <Reveal key={problem.title} as="li" delay={i * 0.03} className="flex h-full flex-col items-center rounded-xl border border-line bg-surface p-4 text-center" data-id="element-141" data-mp="x49uh55jlboc" data-mpi={i}>
                <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-danger-soft" data-id="element-142" data-mp="1714r1ii991zz">
                  <Icon size={17} className="text-danger" data-id="element-143" data-mp="1c2kc3akfn8id" />
                </span>
                <h3 className="mt-2.5 font-display text-sm font-extrabold uppercase text-ink" data-id="element-144" data-mp="1g22xs8k2vnm9">
                  {problem.title}
                </h3>
                <p className="mt-1.5 text-xs leading-relaxed text-ink-muted sm:text-sm" data-id="element-145" data-mp="3hur4wszuev7b">
                  {problem.desc}
                </p>
              </Reveal>;
        })}
        </ul>
      </div>
    </section>;
}